<template>
  <div class="page">
    <div class="bg-content padding15">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="数据图表" name="dataDrawing">
          <data-drawing-list v-if="activeTab === 'dataDrawing'"></data-drawing-list>
        </el-tab-pane>
        <el-tab-pane label="批次报告" name="batchReport">
          <batch-report v-if="activeTab === 'batchReport'"></batch-report>
        </el-tab-pane>
        <!-- <el-tab-pane label="模板统计" name="statistics">
          <template-report v-if="activeTab === 'statistics'" v-bind:changeTabe="activeTab"></template-report>
        </el-tab-pane> -->
        <el-tab-pane label="数据报告" name="report">
          <data-report v-if="activeTab === 'report'"></data-report>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import dataReport from './dataReport';
import templateReport from './templateReport';
import dataDrawingList from './dataDrawingList';
import batchReport from './batchReport';

export default {
  data() {
    return {
      activeTab: null
    };
  },
  mounted() {
    console.warn(this.$route.query.report);
    if (this.$route.query.report === '数据图表') {
      this.activeTab = 'dataDrawing';
      return;
    } else if (this.$route.query.report === '批次报告') {
      this.activeTab = 'batchReport';
      return;
    } else if (this.$route.query.report === '数据报告') {
      this.activeTab = 'report';
      return;
    }
    const type = sessionStorage.getItem('dataReportType');
    if (type) {
      this.activeTab = type;
    } else {
      this.activeTab = 'dataDrawing';
    }
  },
  components: {
    dataReport, templateReport, dataDrawingList, batchReport
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/collection/report/index.vue